import React from 'react';
import './shimmer.css';
import { useTheme } from '../../../styles/ThemeProvider';

export const SkeletonChart = ({ height = 260 }) => {
  const { theme } = useTheme();
  return (
    <div style={{
      background: theme.color.surface,
      border: `1px solid ${theme.color.border}`,
      borderRadius: theme.radius.md,
      padding: theme.space.lg,
    }}>
      <div className="analytics-skeleton" style={{ height: 16, width: '40%', marginBottom: theme.space.lg }} />
      <div className="analytics-skeleton" style={{ height, width: '100%' }} />
    </div>
  );
};
